{
  "EMOJI": {
    "PLACEHOLDER": "جستجوی اموجی",
    "NOT_FOUND": "هیچ اموجی با جستجوی شما مطابقت ندارد",
    "REMOVE": "حذف"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "هیچ اموجی با جستجوی شما مطابقت ندارد",
    "NO_ICON": "No icons match your search",
    "REMOVE": "حذف",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
